import { ViewChild } from '@angular/core';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { DxPopoverComponent } from 'devextreme-angular/ui/popover';
import { ConfirmationService, MessageService } from 'primeng/api';
import { RateOfExchangeProperties } from '../Models/RateOfExchangeProperties';
import { RateOfExchangeService } from '../Services/rate-of-exchange.service';
import { faPenToSquare } from '@fortawesome/free-regular-svg-icons';
import { faP } from '@fortawesome/free-solid-svg-icons';
declare var $;
@Component({
    selector: 'app-rate-of-exchange-list',
    templateUrl: './rate-of-exchange-list.component.html',
    styleUrls: ['./rate-of-exchange-list.component.css']
})
/** RateOfExchangeList component*/
export class RateOfExchangeListComponent {
  @ViewChild(DxPopoverComponent, { static: false }) popOver: DxPopoverComponent;
  /** RateOfExchangeList ctor */
  rateOfExchangeDetails: RateOfExchangeProperties[]=[];
  popoverTarget: any;
  popOverText: string;
  loader: boolean = false;
  collapsed = false;
  faPenToSquare = faPenToSquare;
  constructor(private confirmationService: ConfirmationService, private service: RateOfExchangeService, private messageService: MessageService, private router: Router) {
      this.popoverTarget = "";
      this.popOverText = "hello shoaib";
  }
  contentReady = (e) => {
    $(".dx-datagrid-headers").css({ "background-color": "white", "color": "#212529", "font-weight": "bold" });
    if (!this.collapsed) {
      this.collapsed = true;
      e.component.expandRow(["EnviroCare"]);
    }
  };
  ngOnInit() {
    this.getDataAllROE();
  }
  onCellHoverChanged(e) {

    if (e.rowType === "data" && e.column.dataField === "agencyBranchList" && e.eventType === "mouseover") {

      this.popOverText = e.text;
      this.popoverTarget = e.cellElement;
      this.popOver.width = "auto";
      this.popOver.height = "auto";
      this.popOver.visible = true;
      this.popOver.position = "top";
      this.popOver.instance.show();

    }
    if (e.rowType === "data" && e.eventType === "mouseout") {
      this.popOver.instance.hide();
    }
  }
  DeleteROE(id) {
    //console.log(id);
    this.service.DeleteByIdROE(id, (localStorage.getItem("AgencyId"))).subscribe((data) => {
      if (data == true) {
        this.loader = false;
        this.getDataAllROE();
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Saved Successfully!' });
      }
      else {
        this.loader = false;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Not Deleted.' });
      }
    })
  }
  confirmdelete(obj: RateOfExchangeProperties) {
    let messgae = "";
    let countss = 0;
    for (let o = 0; o < this.rateOfExchangeDetails.length; o++) {
      if (obj.roeid != this.rateOfExchangeDetails[o].roeid) {
        if (obj.supplier == this.rateOfExchangeDetails[o].supplier && obj.officeIDs == this.rateOfExchangeDetails[o].officeIDs) {
          countss++;
          
        }
      }
      
    }
    if (countss ==0) {
      messgae = "Not Any Supplier or PCC is Exist! Please confirm to proceed.";
    }
    else{
      messgae = "Please confirm to proceed.";
    }
    
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: messgae,
      accept: () => {
        this.loader = true;
        this.DeleteROE(obj.roeid);
        
      },
      reject: () => {
        this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
      }
    });
  }
  updateROE(id) {
    localStorage.setItem("ROEID", id);
    localStorage.setItem("TypeRoe", "Update");
    this.router.navigateByUrl("/RateOfExchange");
  }
  createROE() {
    localStorage.setItem("TypeRoe", "Create");
    this.router.navigateByUrl("/RateOfExchange");
  }
  getDataAllROE() {
    this.service.ROEGetAlls().subscribe((data) => {
      this.rateOfExchangeDetails = data;

    });
  }
}
